<template>
  <section class="how">
    <h2 class="how__title content__title content__title--contrast" v-html="content.data.how.header">
    </h2>
    <div class="how__intro content__text" v-html="content.data.how.intro">
    </div>
    <img class="how__img" src="../../assets/images/books.png" />
    <div class="how__boxes">
      <div class="how__box">
        <div class="how__box-title" v-html="content.data.how.content__1_0">
  
        </div>
        <div class="how__box-content">
          → <span v-html="content.data.how.content__1_1"></span><br />
          → <span v-html="content.data.how.content__1_2"></span><br />
          → <span v-html="content.data.how.content__1_3"></span>
        </div>
      </div>
      <div class="how__box">
        <div class="how__box-title" v-html="content.data.how.content__2_0">
          
        </div>
        <div class="how__box-content" v-html="content.data.how.content__2_1">
      
        </div>
      </div>
      <div class="how__box">
        <div class="how__box-title" v-html="content.data.how.content__3_0">
     
        </div>
        <div class="how__box-content" v-html="content.data.how.content__3_1">
        
        </div>
      </div>
    </div>
    <div class="how__cta ">
      <Button :text="content.data.how.btn" /> 
    </div>
    <div class="how__form" id="how__form">
         <InvitationMobile /> 
    </div>
  </section>
</template>

<script>
import Button from "../elements/Button.vue";
import InvitationMobile from "@/components/InvitationMobile.vue";
export default {
  name: "HowToGetBook",
    components: {
    Button, InvitationMobile,
  },
    inject: ['content'],
};
</script>
